import { render, staticRenderFns } from "./MailCerti.vue?vue&type=template&id=5bc0311f&scoped=true&"
import script from "./MailCerti.vue?vue&type=script&lang=js&"
export * from "./MailCerti.vue?vue&type=script&lang=js&"
import style0 from "./MailCerti.vue?vue&type=style&index=0&id=5bc0311f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc0311f",
  null
  
)

export default component.exports